import React from 'react';
import MuiOutlinedInput, { OutlinedInputProps as MuiProps } from '@material-ui/core/OutlinedInput';

export interface OutlinedInputProps extends MuiProps {
    /**
     * The label of the input. It is only used for layout. The actual labelling
     * is handled by `InputLabel`. If specified `labelWidth` is ignored.
     */
    label?: React.ReactNode;
    /**
     * The width of the label. Is ignored if `label` is provided. Prefer `label`
     * if the input label appears with a strike through.
     */
    labelWidth?: number;
    /**
     * If `true`, the outline is notched to accommodate the label.
     */
    notched?: boolean;
}

const OutlinedInput: React.FC<OutlinedInputProps> = (props: OutlinedInputProps) => <MuiOutlinedInput {...props} />;

export default OutlinedInput;
